export default (message: string) => (value: any) => {
  return new RegExp(/^(?:[-+]?(?:0|[1-9]\d*))$/).test(value) || message;
};
